import hyphenateProperty from './hyphenateProperty';
export default function resolveArrayValue(property, value) {
  return value.join(';' + hyphenateProperty(property) + ':');
}


// WEBPACK FOOTER //
// ./node_modules/css-in-js-utils/es/resolveArrayValue.js